import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { formateoBasico } from '../../../../utilities/formateos';
import './ModalVerNotas.scss';

const ModalVerNotas = ({ visible, onHide, notas, servicio }) => {
    const footer = (
        <div className="modal-footer-buttons">
            <Button 
                label="Cerrar" 
                icon="pi pi-times" 
                onClick={onHide} 
                className="p-button-secondary"
            />
        </div>
    );

    return (
        <Dialog
            header={`Notas del Servicio: ${servicio || ''}`}
            visible={visible}
            className="modalDialog modal-ver-notas"
            onHide={onHide}
            footer={footer}
            draggable={false}
        >
            <div className="modal-ver-notas-content">
                {notas && notas.length > 0 ? (
                    <div className="notas-lista">
                        {notas.map((nota, index) => (
                            <div 
                                key={nota.ID || index} 
                                className={`nota-card ${nota.REVISADO ? 'revisada' : 'sin-revisar'}`}
                            >
                                <div className="nota-header">
                                    <div className="nota-info">
                                        <span className="nota-fecha">
                                            <i className="pi pi-calendar" />
                                            {nota.FECHA}
                                        </span>
                                        <span className="nota-usuario">
                                            <i className="pi pi-user" />
                                            Usuario: {nota.ID_USUARIO_REGISTRO}
                                        </span>
                                    </div>
                                    <div className="nota-estado">
                                        <Checkbox
                                            inputId={`revisado-${nota.ID}`}
                                            checked={nota.REVISADO}
                                            disabled
                                        />
                                        <label htmlFor={`revisado-${nota.ID}`}>
                                            {nota.REVISADO ? 'Revisada' : 'Pendiente'}
                                        </label>
                                    </div>
                                </div>
                                
                                <div className="nota-contenido">
                                    <p>{nota.NOTA}</p>
                                </div>
                                
                                {nota.REVISADO && nota.FECHA_REVISION && (
                                    <div className="nota-revision">
                                        <i className="pi pi-check-circle" />
                                        <span>
                                            Revisada el {nota.FECHA_REVISION} por Usuario {nota.ID_USUARIO_REVISION}
                                        </span>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="sin-notas">
                        <i className="pi pi-info-circle" />
                        <p>No hay notas registradas para este servicio</p>
                    </div>
                )}
            </div>
        </Dialog>
    );
};

export default ModalVerNotas;
